/**
 * Skąd pozycja trafiła do koszyka.
 *
 * Praca oglądana w podglądzie prywatnej oferty (`/pv/{grupa}-slug`) ma w tej ofercie
 * własną cenę, więc pozycja koszyka musi nieść identyfikator grupy — inaczej backend
 * wyceni ją ceną katalogową. Poza tym podglądem obie wartości są puste i backend
 * traktuje pozycję jak zwykły zakup z inwentarza.
 *
 * Kontekst czytamy z adresu strony, bo blok kupna nie wie, w jakim widoku został
 * wyrenderowany. Wspólne miejsce, żeby dwie drogi zakupu — blok przycisku obsługiwany
 * globalnie i przycisk konfiguratora ceny — nie rozjechały się w rozpoznawaniu oferty.
 */
export interface CartSourceContext {
  parentType: string;
  grupID: string;
}

/** Typ nadrzędny pozycji kupionej z podglądu prywatnej oferty. */
export const PRIVATE_VIEW_PARENT_TYPE = 'pv';

const ADRES_PRYWATNEJ_OFERTY = /\/pv\/(\d+)-/;

/**
 * Kontekst pochodzenia pozycji odczytany z adresu strony.
 *
 * @param url adres oglądanej strony
 * @return typ nadrzędny i identyfikator grupy; puste teksty poza podglądem oferty
 */
export function cartSourceContextFromUrl(url: string | null | undefined): CartSourceContext {
  const dopasowanie = (url ?? '').match(ADRES_PRYWATNEJ_OFERTY);

  if (!dopasowanie) {
    return {parentType: '', grupID: ''};
  }

  return {parentType: PRIVATE_VIEW_PARENT_TYPE, grupID: dopasowanie[1]};
}
